import React from 'react';
import assign from 'object-assign';
import MenuItem from 'material-ui/MenuItem';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import IconButton from 'material-ui/IconButton';
import { ListItem } from 'material-ui/List';

import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import { Card, CardText } from 'material-ui/Card';

import VenueActions from '../../actions/VenueActionCreator';
import VenueStore from '../../stores/VenueStore';
import ContactActions from '../../actions/ContactActionCreator';
import ContactStore from '../../stores/ContactStore';

const url = '/dashboard/venues';

const VenueForm = React.createClass({

    getInitialState: function () {

        return {

            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),

            searchText: '',
            details: {
                id: '',
                name: '',
                description: '',
                status: 'available',
                contacts: [],
                assets: [],
            },
            dropdowns: {
                statusOptions: ['available', 'unavailable'],
            },
            dataSource: {
                contacts: [],
            }
        }
    },

    componentDidMount: function() {
        VenueStore.addChangeListener(this.onChange);
        if(this.state.isEdit) {
            VenueActions.getById(this.props.routeParams.id);
        }
        ContactStore.addChangeListener(this._onContactDataSourceLoad);
        ContactActions.getAll();
    },

    componentWillUnmount: function() {
        VenueStore.removeChangeListener(this.onChange);
    },

    _onSave: function (model) {

        if(this.state.isEdit) {
            return VenueActions.update(this.props.routeParams.id, model);
        } else {
            return VenueActions.save(model);
        }
    },

    render: function () {

            const venueId = parseInt(this.props.routeParams.id);
            let state = this.state.details;

            let formTitle  = (this.state.isEdit ? 'Edit' : 'New venue');
            let redirectTo = (this.state.isEdit ? '/dashboard/venue/' + this.state.details.id : url);

            let self = this;
            let contacts = [];
            if (this.state.details.contacts) {
                contacts = this.state.details.contacts;
            }

                return(

                        <Form
                            title={formTitle}
                            onSave={this._onSave}
                            redirectTo={redirectTo}
                        >
                            <Card className="cent-card">
                                <CardText>
                                    <TextField
                                        name="name"
                                        validations="minLength:2,maxLength:255"
                                        validationError="Please use only letters, at least 2"
                                        hintText="Name"
                                        value={this.state.details.name}
                                        floatingLabelText="Name"
                                        required
                                    />
                                    <TextField
                                        name="description"
                                        validations="maxLength:600"
                                        validationError="Please use no more than 600 characters"
                                        hintText="Description"
                                        value={this.state.details.description}
                                        floatingLabelText="Description"
                                    />
                                    {/*
                                    <AutoComplete
                                        floatingLabelText="Contact Name"
                                        dataSource={this.state.dataSource.contacts}
                                        maxSearchResults={5}
                                        searchText={this.state.searchText}
                                        onUpdateInput={this._handleUpdateInput}
                                    />
                                    */}

                                    <ul className="pills">
                                        {contacts.map(function(contact, i) {
                                            let deleteContact = self._deleteContact.bind(self, contact);
                                            return (
                                                <span key={i}>
                                                    <li> {contact.name} </li>
                                                    <IconButton id={contact.id} tooltip="delete" onClick={deleteContact}>
                                                        <CancelIcon />
                                                    </IconButton>
                                                </span>
                                            )
                                        })}
                                    </ul>

                                    <TextField
                                        name="contacts"
                                        style={{"display" : "none"}}
                                        value={contacts}
                                    />

                                    <SelectField
                                        name="status"
                                        value={this.state.details.status}
                                        floatingLabelText="Status"
                                        hintText="Status"
                                        autoWidth={true}
                                        required
                                    >
                                        {this.state.dropdowns.statusOptions.map(function(status) {
                                            return (
                                                <MenuItem
                                                    key={status}
                                                    value={status}
                                                    primaryText={status}
                                                />
                                            )
                                        })}
                                    </SelectField>
                                </CardText>
                            </Card>
                        </Form>

            );
    },

    onChange: function() {
        const details = VenueStore.getById(this.props.routeParams.id);
        if (typeof details != 'undefined') {
            this.setState(assign({}, this.state, { details: details }));
        }
    },

    _handleUpdateInput: function(text) {
        this.setState(assign({},this.state,{
          searchText: text,
        }));
    },

    _onContactSelect: function(contact, event) {
        const state = this.state;
        let index = state.details.contacts.indexOf(contact);
        if(typeof state.details.contacts[index] === 'undefined') {
            state.details.contacts.push(contact);
        }
        state.searchText = '';
        this.setState(assign({},this.state, state));
    },

    _deleteContact: function(contact) {
        const state = this.state;
        let index = state.details.contacts.indexOf(contact);
        state.details.contacts.splice(index, 1);
        this.setState(assign({},this.state, state));
    },

    _onContactDataSourceLoad: function() {
        let self = this;
        try {
            const state = this.state;
            state.dataSource.contacts = ContactStore.getAll().map(function(contact) {

                return {
                    text: contact.name,
                    value: <ListItem
                                onClick={self._onContactSelect.bind(self, contact)}
                                key={contact.id}
                                value={contact.id}
                                primaryText={contact.name}
                            />
                };

            });
            this.setState(assign({}, this.state, state));
        } catch(e) {
            console.error(e);
        }
    },
});

export default VenueForm;
